import { Text } from '@uhg-abyss/web/ui/Text';
import { styled } from '@uhg-abyss/web/tools/styled';

export const modalCss = {
  'abyss-modal-base-body': {
    maxWidth: '454px',
    width: '90vw',
    overflowY: 'auto' as const,
  },
  'abyss-modal-base-content-container': {
    maxWidth: '454px',
    width: '90vw',
  },
  'abyss-modal-close-button': {
    marginTop: '18px',
  },
};

export const getRadioCss = (isSelected: boolean) => ({
  'abyss-radio-root': {
    border: `2px solid ${isSelected ? '#002677' : '#CBCCCD'}`,
    borderRadius: '8px',
    backgroundColor: isSelected ? '#F0F4FF' : 'transparent',
    padding: '12px',
    marginBottom: '8px',
    flexDirection: 'row-reverse' as const,
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    width: '100%',
  },
  'abyss-radio-label': {
    width: '100%',
  },
});

export const SubTitle = styled('div', {
  fontSize: '18px',
  fontWeight: '700',
  lineHeight: '24px',
  color: '#002677',
  marginBottom: '16px',
});

export const LocationAddress = styled(Text, {});

export const LocationDistance = styled(Text, {
  '& .abyss-text-root': {
    display: 'block',
    marginTop: '8px',
  },
});
